import pathToRegexp from 'path-to-regexp';

export default (path, params = {}) => {
  let url = pathToRegexp.compile(path)(params);

  try {
    const search = window?.location?.search;
    if (search) {
      const generatedUrl = new URL(url, window.location.origin);
      const currentParams = new URLSearchParams(search);

      currentParams.forEach((value, key) => {
        if (!generatedUrl.searchParams.has(key)) {
          generatedUrl.searchParams.append(key, value);
        }
      });

      url = generatedUrl.pathname + generatedUrl.search;
    }
  } catch (error) {
    console.error(error);
  }
  return url;
};
